import { BfxDialogData } from "./models/bfx-dialog-data.model";
import { IBfxDialog } from "./models/bfx-dialog.interface";
import { Observable, Subject, SubjectLike } from "rxjs";
import { Injectable, ViewChild, Directive } from "@angular/core";
import { Dialog } from "@bfx/primeng/dialog";
import {
  NativeDesktopSupport,
  CLASS_DIALOG_BG,
} from "../bfx-native-desktop/native-desktop-support";

import { LoggerService } from "@bfx/logger";
import { BfxDialogCommand } from "app/bfx-dialogs/models/bfx-dialog-command.enum";
const logger = LoggerService.for(__dirname);

@Directive()
@Injectable()
export abstract class BfxDialogBaseComponent implements IBfxDialog {
  @ViewChild("dialog", { static: true })
  protected _dialog: Dialog;

  public abstract openDialog(dialogData: BfxDialogData): Observable<BfxDialogData>;

  public postOpenDialog(dialogData: BfxDialogData): void {
    NativeDesktopSupport.prepareEmbeddedDialog(dialogData.body, this._dialog, this._dialog.el);
  }

  public closeDialog(): void {
    try {
      if (NativeDesktopSupport.isNativeDesktopContainer()) {
        let element: Element = this._dialog.container;
        if (element != null && element.parentElement != null) {
          element.parentElement.removeChild(element);
        }
      }

      let dialog: any = this._dialog;
      dialog.removeOverlayElement();

      if (NativeDesktopSupport.isNativeDesktopContainer()) {
        if (dialog?.mask != null) {
          dialog.disableModality();
        }
      }
    } catch (e) {
      logger.out.warn(`${this.constructor.name}: Failed to cleanup dialog ${e}`);
    }
  }

  /**
   * Send out an event on the specified Observable to indicate that the dialog is now closed and to cleanup.
   * No further events can be sent on the observable after this call.
   * @param observable
   * @param dialogId
   */
  protected notifyDialogClosed(observable: SubjectLike<BfxDialogData>, dialogId: string) {
    try {
      observable.next(
        new BfxDialogData(BfxDialogCommand.DIALOG_CLOSE_INTERNAL, dialogId, null, null),
      );
      observable.complete();
    } catch (error) {
      logger.out.warn("dialog-base: Error closing dialog stream:", error);
    }
  }
}
